"use client";
import { useState } from "react";
import { Button, Divider, Icon, List, ListItem, ListItemIcon, ListItemText, MenuItem, Typography } from "@mui/material";
import NextLink from "next/link";
import { usePathname } from "next/navigation";
import ExitMenu from "@/app/_components/ExitMenu";
import { useSession } from "next-auth/react";
import UserIcon from "./Icons/UserIcon";
import { bindHover, bindPopover, usePopupState } from "material-ui-popup-state/hooks";
import HoverPopover from "material-ui-popup-state/HoverPopover";
import Home2Icon from "@/app/_components/Icons/Home2Icon";
import ActivityIcon from "@/app/_components/Icons/ActivityIcon";
import EyeIcon from "@/app/_components/Icons/EyeIcon";
import { Roles } from "@/__generated__/graphql";
import SettingIcon from "@/app/_components/Icons/SettingIcon";

export default function AvatarMenu() {
  const popupState = usePopupState({
    variant: "popover",
    popupId: "demoPopover",
  });
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const { data: session, status } = useSession();
  const pathname = usePathname();
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const fullName =
    session?.user?.me.firstName && session?.user?.me.lastName ? session?.user?.me.firstName + " " + session?.user?.me.lastName : null;
  return (
    <>
      {session?.user?.me.roles.includes(Roles.Admin) ? (
        <Button
          // color={"secondary"}
          variant={"outlined"}
          component={NextLink}
          disableElevation={true}
          href={"/admin"}
          startIcon={<SettingIcon />}
          sx={{ borderRadius: 2, whiteSpace: "nowrap" }}
        >
          پنل مدیریت
        </Button>
      ) : (
        <Button color={"inherit"} {...bindHover(popupState)} startIcon={<UserIcon />} sx={{ whiteSpace: "nowrap" }}>
          حساب کاربری
        </Button>
      )}
      <HoverPopover
        {...bindPopover(popupState)}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        slotProps={{
          paper: {
            sx: {
              boxShadow: `3px 6px 24px -6px #A1A1A129,-3px 0px 24px -6px #A1A1A11F`,
              borderRadius: 3,
              // minWidth: {
              //   xs: hasItems ? "200px" : "300px",
              //   md: hasItems ? "200px" : "300px",
              // },
              // maxWidth: {
              //   xs: hasItems ? "330px" : "300px",
              //   md: hasItems ? "330px" : "300px",
              // },
            },
          },
        }}
      >
        <List>
          <ListItem
            sx={{
              color: "grey.800",
              "&.Mui-selected": {
                backgroundColor: "secondary.50",
                color: "secondary.main",
              },
            }}
          >
            <ListItemIcon sx={{ color: "inherit" }}>
              <Icon>
                <UserIcon />
              </Icon>
            </ListItemIcon>

            <ListItemText primary={fullName || session?.user?.me.phoneNumber} secondary={"خوش آمدید"} />
          </ListItem>
          <Divider sx={{ mb: 1 }} />
          <MenuItem
            component={NextLink}
            href={"/profile"}
            sx={{
              color: "grey.800",
              "&.Mui-selected": {
                backgroundColor: "secondary.50",
                color: "secondary.main",
              },
            }}
            selected={pathname === "/profile"}
          >
            <ListItemIcon sx={{ color: "inherit" }}>
              <Icon>
                <Home2Icon />
              </Icon>
            </ListItemIcon>
            <Typography color={"inherit"} variant={"body1"}>
              حساب کاربری
            </Typography>
          </MenuItem>
          <MenuItem
            component={NextLink}
            href={"/profile/orders"}
            sx={{
              color: "grey.800",
              "&.Mui-selected": {
                backgroundColor: "secondary.50",
                color: "secondary.main",
              },
            }}
            selected={pathname === "/profile/orders"}
          >
            <ListItemIcon sx={{ color: "inherit" }}>
              <Icon>
                <ActivityIcon />
              </Icon>
            </ListItemIcon>
            <Typography color={"inherit"} variant={"body1"}>
              پیگیری سفارشات
            </Typography>
          </MenuItem>
          <MenuItem
            component={NextLink}
            href={"/profile/recent-views"}
            sx={{
              color: "grey.800",
              "&.Mui-selected": {
                backgroundColor: "secondary.50",
                color: "secondary.main",
              },
            }}
            selected={pathname === "/profile/recent-views"}
          >
            <ListItemIcon sx={{ color: "inherit" }}>
              <Icon>
                <EyeIcon />
              </Icon>
            </ListItemIcon>
            <Typography color={"inherit"} variant={"body1"}>
              بازدید های اخیر
            </Typography>
          </MenuItem>
          <Divider />
          <ExitMenu />
        </List>
      </HoverPopover>
    </>
  );
}
